import { render, staticRenderFns } from "./detailBase2.vue?vue&type=template&id=46dc9d91&scoped=true&"
import script from "./detailBase2.vue?vue&type=script&lang=js&"
export * from "./detailBase2.vue?vue&type=script&lang=js&"
import style0 from "./detailBase2.vue?vue&type=style&index=0&id=46dc9d91&lang=sass&scoped=true&"
import style1 from "./detailBase2.vue?vue&type=style&index=1&id=46dc9d91&lang=scss&scoped=true&"
import style2 from "./detailBase2.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dc9d91",
  null
  
)

export default component.exports